<app-modal-frame
  [headerText]="inputData.edit ? CONSTS.HEADER_EDIT : CONSTS.HEADER_ADD"
  [rightButton]="{
    text: CONSTS.BUTTON_TEXT,
    type: BUTTON_TYPES.TEXT_BUTTON,
    disable: messageForm.invalid || messageForm.pristine,
  }"
  (emitRightClick)="clickSave()"
  (emitExit)="clickExit()"
>
  <div class="container">
    <form [formGroup]="messageForm">
      <!-- Header RTF Input -->
      <ion-row class="ion-margin-bottom">
        <ion-col>
          <div class="label">
            {{ CONSTS.HEADER.NOTIFICATION }}
          </div>
          <div class="NgxEditor__Wrapper">
            <ngx-editor-menu [editor]="headerEditor" [toolbar]="customToolbar">
            </ngx-editor-menu>
            <ngx-editor
              formControlName="headerText"
              [editor]="headerEditor"
              [placeholder]="CONSTS.HEADER.PLACEHOLDER"
            ></ngx-editor>
          </div>
        </ion-col>
      </ion-row>
      <!-- Body RTF Input -->
      <ion-row class="ion-margin-bottom">
        <ion-col>
          <div class="label">
            {{ CONSTS.BODY.NOTIFICATION }}
          </div>
          <div class="NgxEditor__Wrapper">
            <ngx-editor-menu [editor]="bodyEditor" [toolbar]="customToolbar">
            </ngx-editor-menu>
            <ngx-editor
              formControlName="bodyText"
              [editor]="bodyEditor"
              [placeholder]="CONSTS.BODY.PLACEHOLDER"
            ></ngx-editor>
          </div>
        </ion-col>
      </ion-row>
      <ion-row class="ion-margin-bottom">
        <!-- Display Type Input -->
        <ion-col>
          <app-form-select
            [formControlName]="'displayType'"
            [label]="CONSTS.DISPLAY_TYPE"
            [options]="DISPLAY_OPTIONS"
          ></app-form-select>
        </ion-col>
        <!-- Has Date Time Checkbox -->
        <ion-col>
          {{ CONSTS.LABEL_TEXT }}
          <app-form-checkbox
            formControlName="hasDateTime"
            (valueChanged)="toggleDateTime()"
          ></app-form-checkbox>
        </ion-col>
      </ion-row>
      @if (messageForm.get("hasDateTime")?.value) {
        <!-- Date Selectors -->
        <ion-row class="ion-margin-bottom">
          <!-- Start Date Selector -->
          <ion-col class="ion-margin-end">
            <div class="label">
              {{ CONSTS.START_DATE }}
            </div>
            <app-form-date-picker
              formControlName="startDate"
              [minDate]="defaultDate"
              [maxDate]="defaultDate"
            ></app-form-date-picker>
          </ion-col>
          <!-- End Date Selector -->
          <ion-col>
            <div class="label">
              {{ CONSTS.END_DATE }}
            </div>
            <app-form-date-picker
              formControlName="endDate"
              [minDate]="defaultDate"
              [maxDate]="defaultDate"
            ></app-form-date-picker>
          </ion-col>
          <!-- Time Selectors -->
        </ion-row>
        <!-- Time Selectors -->
        <ion-row class="ion-margin-bottom">
          <!-- Start Time Selector-->
          <ion-col class="ion-margin-end">
            <app-form-time-picker
              [headerText]="CONSTS.START_TIME"
              [defaultStartTime]="defaultTime"
              [form]="messageForm"
              [control]="'startTime'"
              [required]="true"
            ></app-form-time-picker>
          </ion-col>
          <!-- End Time Selector-->
          <ion-col>
            <app-form-time-picker
              [headerText]="CONSTS.END_TIME"
              [defaultStartTime]="defaultTime"
              [form]="messageForm"
              [control]="'endTime'"
              [required]="true"
            ></app-form-time-picker>
          </ion-col>
        </ion-row>
      }
    </form>
  </div>
</app-modal-frame>
